"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _GradientCarouselSectionModule = _interopRequireDefault(require("./GradientCarouselSection.module.scss"));
var _visitClinicPharmacyIcon = _interopRequireDefault(require("./visit-clinic-pharmacy-icon.svg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const GradientCarouselSection = _ref => {
  let {
    heading,
    subHeading,
    items,
    renderItem,
    getItemKey,
    itemWidth = '90%',
    serviceLine
  } = _ref;
  const subHeadingList = Array.isArray(subHeading) ? subHeading : [];
  const hasMultipleSubHeadings = subHeadingList.length > 1;
  const [activeSubHeadingIndex, setActiveSubHeadingIndex] = (0, _react.useState)(0);
  const [activeIndex, setActiveIndex] = (0, _react.useState)(0);
  const stripRef = (0, _react.useRef)(null);
  const rafRef = (0, _react.useRef)(null);

  // Track which card is centered in the strip so the dots reflect the scroll
  // position. Uses getBoundingClientRect so it's independent of item widths
  // and container padding, and throttles with rAF to avoid layout thrash.
  const updateActiveIndex = (0, _react.useCallback)(() => {
    const strip = stripRef.current;
    if (!strip) return;
    const stripRect = strip.getBoundingClientRect();
    const stripCenter = stripRect.left + stripRect.width / 2;
    let closest = 0;
    let minDist = Infinity;
    Array.from(strip.children).forEach((child, i) => {
      const rect = child.getBoundingClientRect();
      const childCenter = rect.left + rect.width / 2;
      const dist = Math.abs(childCenter - stripCenter);
      if (dist < minDist) {
        minDist = dist;
        closest = i;
      }
    });
    setActiveIndex(prev => prev === closest ? prev : closest);
  }, []);
  const handleScroll = (0, _react.useCallback)(() => {
    if (rafRef.current) return;
    rafRef.current = window.requestAnimationFrame(() => {
      rafRef.current = null;
      updateActiveIndex();
    });
  }, [updateActiveIndex]);
  (0, _react.useEffect)(() => () => {
    if (rafRef.current) window.cancelAnimationFrame(rafRef.current);
  }, []);
  const scrollToIndex = index => {
    const strip = stripRef.current;
    const target = strip && strip.children[index];
    if (!target) return;
    strip.scrollTo({
      left: target.offsetLeft - strip.offsetLeft,
      behavior: 'smooth'
    });
  };
  (0, _react.useEffect)(() => {
    if (!hasMultipleSubHeadings) return undefined;
    const interval = setInterval(() => {
      setActiveSubHeadingIndex(prev => (prev + 1) % subHeadingList.length);
    }, 2500);
    return () => clearInterval(interval);
  }, [hasMultipleSubHeadings, subHeadingList.length]);
  if (!items || items.length === 0) return null;
  const activeSubHeading = subHeadingList[activeSubHeadingIndex];

  // A single card fills the strip; multiple cards keep the "peek" width so the
  // next card is partially visible and the row reads as a carousel.
  const hasMultiple = items.length > 1;
  const effectiveItemWidth = hasMultiple ? itemWidth : '100%';
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "mt-16px",
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: `${_GradientCarouselSectionModule.default.container}`,
      children: [heading && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `text-white text-title-s px-3 mb-3 text-center pt-12px ${_GradientCarouselSectionModule.default.heading}`,
        dangerouslySetInnerHTML: {
          __html: heading
        }
      }), serviceLine === 'pharmacy' && subHeading && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `mx-3 mb-3 px-3 py-2 rounded-full flex items-center justify-center gap-8px mt-10px ${_GradientCarouselSectionModule.default.subHeading}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
          src: _visitClinicPharmacyIcon.default,
          alt: "",
          className: `w-24px h-24px rounded-full object-cover ${_GradientCarouselSectionModule.default.subHeadingIcon}`
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          className: "text-white text-body-s",
          children: subHeading
        })]
      }), serviceLine !== 'pharmacy' && activeSubHeading && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: `mx-3 mb-3 px-3 py-2 rounded-full flex items-center justify-center mt-10px ${_GradientCarouselSectionModule.default.subHeading} ${_GradientCarouselSectionModule.default.subHeadingAnimated}`,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: `flex items-center justify-center gap-8px ${hasMultipleSubHeadings ? _GradientCarouselSectionModule.default.subHeadingSlide : ''}`,
          children: [activeSubHeading.icon && /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
            src: activeSubHeading.icon,
            alt: "",
            className: `${_GradientCarouselSectionModule.default.subHeadingIcon}`
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-white text-body-l font-medium",
            children: activeSubHeading.label
          })]
        }, activeSubHeadingIndex)
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        ref: stripRef,
        onScroll: handleScroll,
        className: `flex gap-3 px-3 pb-2 overflow-x-auto snap-x mt-10px ${_GradientCarouselSectionModule.default.strip}`,
        children: items.map((item, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: `flex-shrink-0 snap-start ${_GradientCarouselSectionModule.default.item}`,
          style: {
            '--item-width': effectiveItemWidth
          },
          children: renderItem(item, index)
        }, getItemKey ? getItemKey(item, index) : index))
      }), hasMultiple && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "flex items-center justify-center gap-1 pb-8px",
        children: items.map((_, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
          type: "button",
          "aria-label": `Go to item ${i + 1}`,
          onClick: () => scrollToIndex(i),
          className: `rounded-full ${_GradientCarouselSectionModule.default.dot} ${i === activeIndex ? _GradientCarouselSectionModule.default.dotActive : ''}`
        }, i))
      })]
    })
  });
};
var _default = exports.default = GradientCarouselSection;